var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g, _g2, _g3, _path10, _path11, _g4, _ellipse, _path12, _path13, _path14, _g5, _path15, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewDynamicTower(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 169,
    viewBox: "0 0 31 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8402 99.9033C6.16987 99.1901 4.1198 98.1582 2.9418 97.2478C2.62787 96.9994 2 96.4205 2 96.092C2 95.7635 2.0153 94.1499 2.0153 93.3643L31 91.1196V92.9899C31 93.0508 30.949 93.1326 30.9235 93.1659C30.5104 93.5453 29.1917 94.7046 27.2212 96.307C25.2507 97.9094 23.4627 98.6438 22.8151 98.8107C17.8705 100.134 14.1049 100.09 12.8402 99.9033Z",
    fill: "#838B96"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.16227 91.1606L9.98656 88L29.5373 89.6381L30.5383 90.6695C30.6344 90.7896 30.7931 91.0682 30.6597 91.2213C30.2501 91.6005 28.9427 92.7593 26.9892 94.3609C25.0356 95.9626 23.2631 96.6967 22.621 96.8635C17.7189 98.1861 13.9857 98.1427 12.7318 97.9556C6.11886 97.2427 4.08642 96.2113 2.91855 95.3013C2.11685 94.6766 1.95795 93.6733 2.00851 93.2082C2.06918 92.374 3.47974 91.5853 4.16227 91.1606Z",
    fill: "#606670"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.16227 91.1606L9.98656 88L29.5373 89.6381L30.5383 90.6695C30.6344 90.7896 30.7931 91.0682 30.6597 91.2213C30.2501 91.6005 28.9427 92.7593 26.9892 94.3609C25.0356 95.9626 23.2631 96.6967 22.621 96.8635C17.7189 98.1861 13.9857 98.1427 12.7318 97.9556C6.11886 97.2427 4.08642 96.2113 2.91855 95.3013C2.11685 94.6766 1.95795 93.6733 2.00851 93.2082C2.06918 92.374 3.47974 91.5853 4.16227 91.1606Z",
    fill: "#7D8590"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.56773 88.59C10.2351 87.4373 10.6648 85.6829 10.7963 84.9498C14.1786 84.7861 21.3983 83.2058 23.2183 78.1946L24.1949 66.1149C24.1975 66.0741 24.2006 66.0358 24.2042 66L24.1949 66.1149C24.0903 67.7809 24.9023 73.5553 29.0123 84.4283C29.1437 84.757 29.4006 85.5598 29.3763 86.1422C29.352 86.7247 29.3257 88.8864 29.3156 89.8944C28.355 90.6629 25.9909 92.5426 24.2194 93.9137C22.4478 95.2849 19.3658 95.9816 18.0463 96.1585C12.1613 96.932 8.52118 95.8248 7.26228 95.385C6.6603 95.1746 5.19043 94.6387 4.30466 93.5952C3.41888 92.5517 4.67373 91.4819 5.41187 91.0774C6.2663 90.6123 8.11166 89.6001 8.65769 89.2725C9.20371 88.9449 9.49189 88.681 9.56773 88.59Z",
    fill: "#344054"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.56773 88.59C10.2351 87.4373 10.6648 85.6829 10.7963 84.9498C14.1786 84.7861 21.3983 83.2058 23.2183 78.1946L24.1949 66.1149C24.1975 66.0741 24.2006 66.0358 24.2042 66L24.1949 66.1149C24.0903 67.7809 24.9023 73.5553 29.0123 84.4283C29.1437 84.757 29.4006 85.5598 29.3763 86.1422C29.352 86.7247 29.3257 88.8864 29.3156 89.8944C28.355 90.6629 25.9909 92.5426 24.2194 93.9137C22.4478 95.2849 19.3658 95.9816 18.0463 96.1585C12.1613 96.932 8.52118 95.8248 7.26228 95.385C6.6603 95.1746 5.19043 94.6387 4.30466 93.5952C3.41888 92.5517 4.67373 91.4819 5.41187 91.0774C6.2663 90.6123 8.11166 89.6001 8.65769 89.2725C9.20371 88.9449 9.49189 88.681 9.56773 88.59Z",
    fill: "#666D77"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.29719 89.0491C9.15159 88.9885 9.23652 88.852 9.29719 88.7913C9.41853 88.6984 9.67335 88.5003 9.72188 88.4518C9.77042 88.4033 9.85333 88.2597 9.88872 88.194C10.1921 87.5418 10.8352 85.9401 10.9808 84.751C11.1982 84.8307 11.8665 85.0041 12.8009 85.0601C12.6643 87.4414 11.5116 89.3373 11.4055 89.5497C11.3205 89.7195 11.1577 89.7519 11.0869 89.7468C10.551 89.5396 9.4428 89.1098 9.29719 89.0491Z",
    fill: "#949CA6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1.30339 71.728L1.22755 17.5351C1.22142 13.1507 3.26108 9.88341 5.33579 7.81281C6.42482 6.72595 7.5235 5.9688 8.34104 5.55287C10.606 4.4861 16.2137 2.75503 19.8227 5.38603C23.7966 8.28299 24.6897 11.9535 24.6763 14.3044C24.5752 32.0401 24.4548 69.3923 24.4184 72.7897C24.382 76.1872 23.2404 78.8061 22.6742 79.6909C21.0867 82.3148 16.2493 86.9075 9.59993 84.2866C5.95886 82.8514 3.81616 80.1501 2.62345 77.4916C1.63803 75.2952 1.3011 73.1279 1.30339 71.728Z",
    fill: "currentColor",
    stroke: "#9DA4AE",
    strokeWidth: 0.313044
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1.75919 13.2757C4.00396 6.79624 9.01424 5.06514 11.2388 5.00952C18.4948 4.71831 20.0561 11.1776 19.9297 14.4436C19.8488 33.0236 19.69 70.7388 19.7022 72.9593C19.7143 75.1798 18.6657 77.7572 18.1399 78.7684C16.15 82.6755 11.8404 82.9748 9.9344 82.636C2.88462 81.2043 1.16261 74.5367 1.18284 71.3819C1.13228 54.2984 1.02509 19.6673 1.00082 17.8108C0.976553 15.9543 1.49629 14.0139 1.75919 13.2757Z",
    fill: "#949CA6",
    stroke: "#78808E",
    strokeWidth: 0.2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5.08054 17.7061C5.84772 9.98595 10.7512 10.0118 11.3295 10.0011C14.6208 9.94045 16.8352 12.352 16.649 18.8487C16.5992 35.7486 16.509 70.0534 16.509 72.0731L16.5089 72.1438C16.5065 73.5398 16.5056 74.0504 16.3022 74.8112C15.6673 76.9498 12.7734 79.7861 9.32738 78.6941C5.88135 77.602 5.02996 73.7293 5.03502 71.9294C5.00391 56.3907 5.02012 23.5999 5.0052 21.9113C4.99027 20.2227 5.00517 18.4645 5.08054 17.7061Z",
    fill: "#838B96"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5324_1711)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.08216 18.9457C7.26919 18.5695 7.05584 17.5351 7.05078 17.0649L9.35622 16.5644C10.0084 16.4734 11.1915 16.9588 11.4341 18.2176C11.6564 19.3704 11.2976 20.1439 10.964 20.5989C10.5393 21.0994 10.0873 21.4786 9.25005 21.7213V21.5089L9.28038 20.5989C9.72934 20.514 9.84157 20.4776 10.2056 20.1136C10.9039 19.4152 10.873 18.0811 9.84157 17.7019C8.78637 17.314 8.22372 18.3845 8.08216 18.9457Z",
    fill: "#E6E8EC"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_5324_1711)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.82793 15.6543C9.30617 15.7029 9.2364 15.1487 9.26674 14.8656C9.75209 14.7948 10.7774 14.6472 10.9958 14.6229C11.2142 14.5987 11.289 14.7241 11.2992 14.7898V15.4116L9.82793 15.6543Z",
    fill: "#E6E8EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.375 16.534L11.4357 15.533L12.8614 15.2903L11.375 16.534Z",
    fill: "#E6E8EC"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_5324_1711)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.71546,
    cy: 72.4143,
    rx: 2.94061,
    ry: 3.5037,
    transform: "rotate(-9.28549 9.71546 72.4143)",
    fill: "url(#paint1_linear_5324_1711)"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5876 71.9448C12.898 73.843 11.8574 75.5836 10.2759 75.8422C8.69436 76.1008 7.15368 74.7822 6.84332 72.8839C6.53296 70.9856 7.57348 69.2451 9.15502 68.9865C10.7366 68.7279 12.2772 70.0465 12.5876 71.9448Z",
    stroke: "#384250",
    strokeWidth: 0.0606694
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6985 72.1687C11.9266 73.5638 11.1617 74.8405 10.0025 75.0301C8.84321 75.2196 7.71154 74.253 7.48344 72.8578C7.25534 71.4627 8.02022 70.1859 9.17949 69.9964C10.3388 69.8068 11.4704 70.7735 11.6985 72.1687Z",
    fill: "url(#paint2_radial_5324_1711)",
    stroke: "#384250",
    strokeWidth: 0.0606694
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_5324_1711)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.4051,
    cy: 19.0088,
    rx: 0.650993,
    ry: 0.775649,
    transform: "rotate(-1.39963 9.4051 19.0088)",
    fill: "#8051AA"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.51575,
    cy: 72.456,
    rx: 1.6333,
    ry: 1.94606,
    transform: "rotate(-9.28549 9.51575 72.456)",
    fill: "url(#paint3_radial_5324_1711)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9244 72.2211C11.0797 73.1705 10.5593 74.0416 9.76762 74.1711C8.97597 74.3005 8.20522 73.6405 8.04998 72.691C7.89474 71.7415 8.41517 70.8704 9.20681 70.741C9.99846 70.6116 10.7692 71.2716 10.9244 72.2211Z",
    stroke: "#1F2A37",
    strokeWidth: 0.0273012
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7744 72.2479C10.9141 73.1024 10.4457 73.8864 9.73324 74.0029C9.02076 74.1194 8.32708 73.5254 8.18737 72.6709C8.04765 71.8163 8.51604 71.0323 9.22852 70.9158C9.94101 70.7994 10.6347 71.3933 10.7744 72.2479Z",
    stroke: "#1F2A37",
    strokeWidth: 0.0245711
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6502 72.2898C10.7759 73.0589 10.3544 73.7645 9.71314 73.8694C9.07191 73.9742 8.4476 73.4396 8.32185 72.6705C8.19611 71.9014 8.61766 71.1958 9.25889 71.091C9.90013 70.9862 10.5244 71.5208 10.6502 72.2898Z",
    stroke: "#1F2A37",
    strokeWidth: 0.022114
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_5324_1711)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.68945 83.8865C14.1487 85.0544 22.3603 83.4436 22.2025 70.2055C22.0448 56.9674 22.1368 26.7813 22.2025 13.3431C21.9042 9.08104 17.9557 3.24161 11.8887 4.77352",
    stroke: "white",
    strokeWidth: 0.521739
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1627 91.9738C29.2417 82.0392 27.3003 79.9006 24.2365 73.5C24.2365 74.5314 23.9736 75.9946 23.456 77.5952C24.8868 79.7591 26.7989 85.7097 23.001 92.2014C22.996 92.2266 23.0071 92.2772 23.092 92.2772C23.177 92.2772 25.0891 92.2266 26.0345 92.2014C26.0539 92.2014 26.1067 92.1558 26.1627 91.9738Z",
    fill: "#7D8590"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5324_1711",
    x: 6.68676,
    y: 16.129,
    width: 5.42286,
    height: 6.13828,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.121339,
    dy: 0.0606694
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.242678
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5324_1711"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5324_1711",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_5324_1711",
    x: 8.83606,
    y: 14.1952,
    width: 4.5713,
    height: 2.88486,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.0606694,
    dy: 0.0606694
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.242678
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5324_1711"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5324_1711",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_5324_1711",
    x: 6.51513,
    y: 68.8024,
    width: 6.15772,
    height: 7.10254,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.242678,
    dy: -0.121339
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.151674
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_5324_1711"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_5324_1711",
    x: 8.32922,
    y: 17.8086,
    width: 2.27345,
    height: 2.52186,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.0606694,
    dy: 0.0606694
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.242678
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5324_1711"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5324_1711",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_5324_1711",
    x: 8.16698,
    y: 2.80651,
    width: 15.7549,
    height: 83.1082,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.728033,
    result: "effect1_foregroundBlur_5324_1711"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5324_1711",
    x1: 2.07691,
    y1: 12.5999,
    x2: 23.205,
    y2: 78.0015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5E7EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.078125,
    stopColor: "#D1D1D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.973958,
    stopColor: "#9DA4AE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5324_1711",
    x1: 12.5744,
    y1: 72.0727,
    x2: 6.83045,
    y2: 72.4246,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5E7EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAECF0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_5324_1711",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.50939 72.526) rotate(79.5715) scale(2.5138 2.19934)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.769445,
    stopColor: "#667085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789313,
    stopColor: "#98A2B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.871256,
    stopColor: "#F2F4F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893429,
    stopColor: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.939524,
    stopColor: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.967989,
    stopColor: "#98A2B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#475467"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_5324_1711",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.51575 72.456) rotate(90) scale(1.94606 1.6333)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D5761"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#344054"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewDynamicTower);
export default __webpack_public_path__ + "static/media/NewDynamicTower.f183d751f0d41853947e899e8b4d2944.svg";
export { ForwardRef as ReactComponent };